import { render, staticRenderFns } from "./MemberLookup.vue?vue&type=template&id=5307b6f5&scoped=true"
import script from "./MemberLookup.vue?vue&type=script&lang=js"
export * from "./MemberLookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5307b6f5",
  null
  
)

export default component.exports